/*
 */

export const hlp_getContentDate = (def: any /* yes, any! */, alt: any /* yes, any! */): Date => {
  let res = new Date();
  try {
    res = def ? new Date(def) : new Date(alt);
  } catch (err) {
    console.warn('Invalid date: ', def, alt);
    res = new Date();
    // !skip error
  }
  return res;
};

export const hlp_dateToISOString = (date: any): string => {
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? '' : d.toISOString();
  } catch {
    return '';
  }
};
